// imports
import React from 'react';
import { PlacesType, Tooltip } from 'react-tooltip';

// interfaces / types / consts
interface Props {
  title: string;
  anchorSelect: string;
  description: string | JSX.Element;
  place?: PlacesType;
  openOnClick?: boolean;

}

// exports
export default function InfoTooltip(props: Props): JSX.Element {
  const {
    title, description, anchorSelect, place = 'top', openOnClick = true
  } = props;
  return (
    <Tooltip openOnClick={openOnClick} anchorSelect={anchorSelect} variant="light" place={place}>
      <div className="tool-tip">
        <div className="heading">{title}</div>
        <div className="description">{description}</div>
      </div>
    </Tooltip>
  );
}

// default props
InfoTooltip.defaultProps = { place: 'top', openOnClick: true };
